module.exports = __webpack_public_path__ + "img/Cannon20_Regular.4f4c9643.png";